'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_ImportState() {
}
export { $c_Lmealorama_ImportState as $c_Lmealorama_ImportState };
$p = $c_Lmealorama_ImportState.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_ImportState;
/** @constructor */
function $h_Lmealorama_ImportState() {
}
export { $h_Lmealorama_ImportState as $h_Lmealorama_ImportState };
$h_Lmealorama_ImportState.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
var $d_Lmealorama_ImportState = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i(0, "mealorama.ImportState", ({
  jD: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lmealorama_ImportState as $d_Lmealorama_ImportState };
//# sourceMappingURL=mealorama.-Import-State.js.map
